import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { GuaranteeLine } from './ui/GuaranteeLine';
import { FULL_MOCKUP_URL } from '../data/images';
import { BASE_CHECKOUT_URL, KIT_CHECKOUT_URL } from '../data/checkoutLinks';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function FinalCTA() {
  return <section className="relative overflow-hidden bg-mp-black py-20 md:py-28" data-id="element-96" data-mp="m2lustwz5prg">
      <div className="pointer-events-none absolute inset-0 court-lines opacity-40" aria-hidden="true" data-id="element-97" data-mp="h5lpwmbv2t1x" />
      <div className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(ellipse at 50% 20%, rgba(8,93,168,0.3), transparent 65%)'
    }} aria-hidden="true" data-id="element-98" data-mp="vwuk78qpl2le" />
      <Container className="relative z-10 text-center" data-id="element-99" data-mp="14t3j8marxz70">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: easeOut
      }} data-id="element-100" data-mp="zxo8i382cjet">
          <SectionTag tone="white" data-id="element-101" data-mp="2h3zqg181s4lo">La próxima clase llegará igualmente.</SectionTag>
          <h2 className="mx-auto mt-5 max-w-[820px] font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-102" data-mp="2m19g9hzcmia1">
            La pregunta es si volverás a improvisarla.
          </h2>

          <p className="mx-auto mt-6 max-w-[600px] text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-103" data-mp="2v38xobe9zodi">
            Necesitas saber qué trabajar, por qué trabajarlo, cómo corregirlo y qué viene después. Eso es Maestro
            en Pista.
          </p>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: easeOut
      }} src={FULL_MOCKUP_URL} alt="Sistema completo Maestro en Pista" width={600} height={600} loading="lazy" className="mx-auto mt-12 w-full max-w-[380px]" data-id="element-104" data-mp="39rdlfts6qq35" />

        <div className="mx-auto mt-10 grid max-w-[760px] grid-cols-1 gap-5 text-left sm:grid-cols-2" data-id="element-105" data-mp="1en5s6kf7easi">
          <div className="rounded-2xl border border-mp-border bg-mp-dark/80 p-6" data-id="element-106" data-mp="1sihvvhbc7blk">
            <p className="font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-107" data-mp="1nongur6ofkst">Maestro en Pista</p>
            <p className="mt-3 font-heading text-4xl text-mp-white" data-id="element-108" data-mp="22gxnrmi6uow4">17,90 €</p>
            <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-109" data-mp="1xf8b62fbi35x">Pago único</p>
            <CTAButton href={BASE_CHECKOUT_URL} variant="secondary" className="mt-5 w-full" showArrow data-id="element-110" data-mp="2bezkvqyswxe4">
              Quiero la versión base
            </CTAButton>
          </div>

          <div className="relative rounded-2xl border-2 border-mp-lime bg-mp-dark/80 p-6 shadow-glow-lime" data-id="element-111" data-mp="h2jg6ulnlrbd">
            <span className="absolute -top-3 left-6 rounded-full bg-mp-lime px-3 py-1 font-heading text-[10px] font-bold uppercase tracking-wide text-mp-black" data-id="element-112" data-mp="d17xza5408d7">
              Recomendado
            </span>
            <p className="mt-2 font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-113" data-mp="6x1qu16t3vry">
              Maestro en Pista + Kit de Ejecución
            </p>
            <p className="mt-3 font-heading text-4xl text-mp-lime" data-id="element-114" data-mp="3ua41fhhtsp4f">23,90 €</p>
            <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-115" data-mp="3fdd0h3si75cp">
              Solo 6 € más que la versión base
            </p>
            <CTAButton href={KIT_CHECKOUT_URL} className="mt-5 w-full" showArrow data-id="element-116" data-mp="3kd93p0tdmsr7">
              Quiero el sistema completo
            </CTAButton>
          </div>
        </div>

        <GuaranteeLine className="mt-6" data-id="element-117" data-mp="3bazvwiphtdhi" />
      </Container>
    </section>;
}